import { Controller } from 'react-hook-form';
import { Col } from 'reactstrap';
import { Select, TextInput, SelectOptionType } from '@octano/global-ui';
import { SectionTitle } from '../../../../components/text';

interface GeneralFieldsProps {
  control: any;
  facultyOptions: SelectOptionType[];
  coursesOptions: SelectOptionType[];
  courseNamesOptions: SelectOptionType[];
  campusOptions: SelectOptionType[];
  schedulesOptions: SelectOptionType[];
  msgValidations: any;
  rulesPatternNumeric: any;
  loadingFormData: boolean;
  loadingCourses: boolean;
  t: any;
  prefix: string;
  onCourseChange: (option: SelectOptionType) => void;
  onCourseNameChange: (option: SelectOptionType) => void;
}

export function ContinuousEducationSectionGeneralFields({
  control,
  facultyOptions,
  coursesOptions,
  courseNamesOptions,
  campusOptions,
  schedulesOptions,
  msgValidations,
  rulesPatternNumeric,
  loadingFormData,
  loadingCourses,
  t,
  prefix,
  onCourseChange,
  onCourseNameChange,
}: GeneralFieldsProps) {
  return (
    <>
      <Col xs={12}>
        <SectionTitle text={t(`${prefix}.generalSection`)} />
        <p className="fs-16">
          {t(`${prefix}.continuousEducationSectionDescription`)}
        </p>
      </Col>
      <Col xs={12} md={3}>
        <Select
          name="faculty"
          label={t('sectionsMaintainer.create.facultyLabel')}
          options={facultyOptions}
          control={control}
          rules={{ required: msgValidations.required }}
          disabled={loadingFormData}
        />
      </Col>
      <Col xs={12} md={3}>
        <Controller
          control={control}
          name="courseName"
          rules={{ required: msgValidations.required }}
          render={({ field: { onChange, value, ref, ...field } }) => (
            <Select
              {...field}
              value={value}
              label={t('sectionsMaintainer.create.courseLabel')}
              options={courseNamesOptions}
              isSearchable
              disabled={loadingCourses}
              onChange={(val: any) => {
                onChange(val);
                onCourseNameChange(val);
              }}
            />
          )}
        />
      </Col>
      <Col xs={12} md={3}>
        <Controller
          control={control}
          name="course"
          rules={{ required: msgValidations.required }}
          render={({ field: { onChange, value, ref, ...field } }) => (
            <Select
              {...field}
              value={value}
              label={t(`${prefix}.coursesLabel`)}
              options={coursesOptions}
              isSearchable
              disabled={loadingCourses}
              onChange={(val: any) => {
                onChange(val);
                onCourseChange(val);
              }}
            />
          )}
        />
      </Col>
      <Col xs={12} md={3}>
        <Select
          name="campus"
          label={t('sectionsMaintainer.create.campusLabel')}
          options={campusOptions}
          control={control}
          rules={{ required: msgValidations.required }}
          disabled={loadingFormData}
        />
      </Col>
      <Col xs={12} md={3}>
        <Select
          name="schedule"
          label={t(`${prefix}.schedulesLabel`)}
          options={schedulesOptions}
          control={control}
          rules={{ required: msgValidations.required }}
          disabled={loadingFormData}
        />
      </Col>
      <Col xs={12} md={3}>
        <TextInput
          name="name"
          label={t(`${prefix}.sectionNameLabel`)}
          control={control}
          rules={{ required: msgValidations.required }}
        />
      </Col>
      <Col xs={12} md={3}>
        <TextInput
          name="sectionCode"
          label={t(`${prefix}.sectionCodeLabel`)}
          control={control}
          rules={{ required: msgValidations.required }}
        />
      </Col>
      <Col xs={12} md={3}>
        <TextInput
          name="quota"
          label={t('sectionsMaintainer.create.quotaLabel')}
          control={control}
          rules={{
            required: msgValidations.required,
            pattern: rulesPatternNumeric,
          }}
        />
      </Col>
    </>
  );
}
